import React from "react";
import styled from "styled-components";
import { SearchIcon } from "../assets/svg/SearchIcon";
import { CloseIcon } from "../assets/svg/CloseIcon";

interface IProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => Promise<void>;
  onClear: () => void;
}

const SearchComponent: React.FC<IProps> = ({ value, onChange, onSearch, onClear }) => {
  return (
    <InputContainer>
      <Icon>
        <SearchIcon />
      </Icon>
      <Input 
        placeholder="Search" 
        value={value}
        onChange={onChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onSearch();
          }
        }}
      />
      {value && (
        <CloseIconContainer onClick={onClear}>
          <CloseIcon />
        </CloseIconContainer>
      )}
      <SearchButton onClick={onSearch}>Search</SearchButton>
    </InputContainer>
  );
};

export default SearchComponent;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 1em;
  width: 70%;
`;

const Input = styled.input`
  padding: 1em 2em;
  font-weight: 600;
  color: #214160;
  box-shadow: none;
  border: 1.5px solid rgba(76, 92, 251, 0.1);
  border-radius: 0.4em;
  background: transparent !important;
  height: 0.675em;
  width: 65%;
  flex: 1;
  margin-right: 5em;

  ::placeholder {
    color: #01A8CE;
    opacity: 0.5;
    font-size: 0.75em;
  }
  &:focus {
    border-radius: 0.5em;
    box-shadow: none;
    outline: none;
  }
`;

const Icon = styled.span`
  position: absolute;
  left: 1.2em;
  top: 50%;
  transform: translateY(-50%);
`;

const CloseIconContainer = styled.span`
  position: absolute;
  right: 6em;
  top: 53%;
  transform: translateY(-50%);
  cursor: pointer;
`;

const SearchButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #01A8CE;
  border: none;
  border-radius: 0.4em;
  color: white;
  padding: 0.5em 1em;
  cursor: pointer;
  font-weight: 600;
  margin-left: 1em;
  &:hover {
    background-color: #172c45;
  }
`;
